<template>
  <div>
    <PageTitle title="Food Order Reports" />
    <v-container fluid class="lighten-12 content">
      <v-card class="lighten-12 card-content">
        <TableFilters
          :filters="[
            'search',
            'guest',
            'dateRange',
            'orderType',
            'orderstatus',
            'biller',
          ]"
          :columns="columns"
          v-model="filter"
          :export="[`productexport`]"
          @clear="onClearFilters"
        ></TableFilters>
        <v-row class="py-0 my-0">
          <v-col cols="12" class="py-0 my-0">
            <v-row class="py-0 my-0">
              <v-col cols="auto" class="py-1 pr-2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      v-bind="attrs"
                      v-on="on"
                      shaped
                      block
                      height="30px"
                      class="report-button"
                      color="blue"
                      @click="
                        generateReport();
                        hide = true;
                      "
                    >
                      <v-icon small>mdi-file-send </v-icon>Generate
                    </v-btn>
                  </template>
                  <span>Genarate</span>
                </v-tooltip>
              </v-col>
              <v-col cols="auto" class="py-1 pr-2" v-if="hide"><v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }"
                    ><v-btn
                      depressed
                      v-bind="attrs"
                      v-on="on"
                      class="report-button"
                      color="red"
                      height="30px"
                      block
                      @click="exportPDF()"
                    >
                      <v-icon small>mdi-file-pdf </v-icon>Export
                    </v-btn>
                  </template>
                  <span>Export to PDF</span>
                </v-tooltip></v-col
              >
              <v-col cols="auto" class="py-1 pr-2" v-if="hide">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      height="30px"
                      v-bind="attrs"
                      v-on="on"
                      block
                      class="report-button"
                      color="green"
                      @click="exceldownload()"
                    >
                      <v-icon small>mdi-file-excel </v-icon>Export
                    </v-btn>
                  </template>
                  <span>Export to Excel</span>
                </v-tooltip></v-col
              >
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="mt-2">
        <v-container fluid>
          <v-row>
            <v-card-text class="pa-0">
              <v-data-table
                :v-model:options="pagination"
                :items-per-page="pagination.itemsPerPage"
                :items-per-page-options="[5, 10, 20, 50, 100, 1000, -1]"
                fixed-header
                :headers="headers"
                :items="foodorders"
                :search="filter.search"
                :custom-filter="filterText"
                height="350px"
                item-key="id"
                class="row-pointer "
                id="indextable"
              >
                <template v-slot:item.date="{ item }">{{
                  item.date | formatDate
                }}</template>

                <template v-slot:item.waiter="{ item }">{{
                  item.waiter && item.waiter.name ? item.waiter.name : "-"
                }}</template>

                <template v-slot:item.items="{ item }">
                  <div v-for="(food, index) in item.items" :key="index">
                    {{ food.dish ? food.dish.name : "" }}
                    {{ food.product ? food.product.name : "" }}
                    - {{ food.unit ? food.unit.name : "" }}
                    - {{ food.quantity ? food.quantity : "" }}
                    - {{ food.amount ? food.amount : "" }}
                  </div>
                </template>
                <template v-slot:item.paid_amount="{ item }">
                  <div v-if="item.status != 'cancelled'">
                    {{ item.paid_amount }}
                  </div>
                  <div v-else>{{ 0 | formatCurrency }}</div></template
                >
                <template v-slot:item.payments="{ item }">
                  <div v-for="(payment, index) in item.payments" :key="index">
                    {{ payment.payment_type ? payment.payment_type : "" }}
                    - {{ payment.amount ? payment.amount : "" }}
                  </div>
                </template>
                <template v-slot:item.unit="{ item }">{{
                  item.table && item.table.name ? item.table.name : "-"
                }}</template>
                <template v-slot:item.createdby="{ item }">{{
                  item.createdby && item.createdby.first_name ? item.createdby.first_name : "-"
                }}</template>

                <template v-slot:item.status="{ item }">{{
                  StatusChenge(item.status)
                }}</template>
                <template v-slot:item.order_type="{ item }">{{
                  OrderTypeChenge(item.order_type)
                }}</template>
                <template
                  slot="body.append"
                  v-if="foodorders && foodorders.length > 0"
                >
                  <tr class="black--text">
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title">
                      {{ servicecharge | formatCurrency }}
                    </th>
                    <th class="title">
                      {{ descount | formatCurrency }}
                    </th>
                    <th>
                      <h3 class="title">
                        {{ total | formatCurrency }}
                      </h3>
                    </th>
                    <th>
                      <h3 class="title">
                        {{ paidamount | formatCurrency }}
                      </h3>
                    </th>
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title"></th>
                    <th class="title"></th>

                    <th class="title"></th>
                    <!-- <th class="title"></th> -->
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>
      <div class="d-flex justify-center align-center"></div>
      <!-- </v-row> -->
    </v-container>
  </div>
</template>

<script>
// Components
import PageTitle from "@/components/shared/PageTitle";
import TableFilters from "@/components/base/TableFilters";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import XLSX from "xlsx";
import { DateTime } from "@grapecity/wijmo";
import moment from "moment";
import _ from "lodash";
export default {
  data: () => ({
    columns: [
      {
        text: "Number",
        value: "no",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Date",
        value: "date",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Order Number",
        value: "order_number",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Order Type",
        value: "order_type",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Food Items",
        value: "items",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Service Charge",
        value: "service_charge",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Discount",
        value: "descount",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Total Amount",
        value: "total_amount",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Paid Amount",
        value: "paid_amount",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Payment Type",
        value: "payments",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Status",
        value: "status",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Guest",
        value: "guest.name",
        show: true,
        disabled: false,
        width: "14%",
      },

      {
        text: "Waiter",
        value: "waiter",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Table",
        value: "table.name",
        show: true,
        disabled: false,
        width: "14%",
      },
      {
        text: "Room",
        value: "room.name",
        show: true,
        disabled: false,
        width: "14%",
      },

      {
        text: "Created By",
        value: "createdby",
        show: true,
        disabled: false,
        width: "14%",
      },
    ],
    pagination: {
    page: 1,
    itemsPerPage: -1,
  },
    foodorders: [],
    date_range: [],
    // Filters
    total: 0,
    paidamount: 0,
    servicecharge: 0,
    descount: 0,
    filter: {
      search: "",
      start: "",
      end: "",
    },
  }),
  components: {
    PageTitle,
    TableFilters,
  },

   mounted() {
    this.generateReport();
  },

  methods: {
    dateFormat: function(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += parseFloat(element[filed]);
      });
      return value;
    },
    generateReport() {
      var filter = this.filter;

        if (filter.start && !filter.end) {
        filter.end = moment(filter.start)
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        filter.start = moment(filter.start)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      }

      if (filter.start && filter.end) {
        filter.start = moment(filter.start)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        filter.end = moment(filter.end)
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      }

      this.$store
        .dispatch("report/getOrderReports", filter)
        .then((res) => {
          let i = 1;
          this.foodorders = res.data.data;
          this.foodorders.map((p) => {
            p.no = i;
            i++;
          });
          this.total = this.sumField(this.foodorders, "total_amount");
          let value = 0;
          this.foodorders.map((i) => {
            if (i.status != "cancelled") {
              (value += parseFloat(i.paid_amount)), (this.paidamount = value);
            }
          });
          this.servicecharge = this.sumField(this.foodorders, "service_charge");
          this.descount = this.sumField(this.foodorders, "descount");
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    exportPDF() {
      const today = new DateTime();
      let Data = _.cloneDeep(this.foodorders);

      for (let x = 0; x < Data.length; x++) {
        Data[x].date = moment(Data[x].date, "YYYY-MM-DD").format("DD/MM/YYYY");
        Data[x].waiter = Data[x].waiter?.name || "-";
        Data[x]['table.name'] = Data[x].table?.name || "-";
        Data[x]['room.name'] = Data[x].room?.name || "-";
        Data[x]['guest.name'] = Data[x].guest?.name || "-";

        Data[x].createdby = Data[x].createdby?.first_name || "-";

            // Convert food items → string
    if (Array.isArray(Data[x].items)) {
      Data[x].items = Data[x].items
        .map((food) => {
          let name =
            food.dish?.name ||
            food.product?.name ||
            "";

          let unit = food.unit?.name || "";
          let qty = food.quantity || "";
          let amt = food.amount || "";

          return `${name} - ${unit} - ${qty} - ${amt}`;
        })
        .join("\n"); // line break inside cell
    }

    // Convert payments → string
    if (Array.isArray(Data[x].payments)) {
      Data[x].payments = Data[x].payments
        .map((pay) => `${pay.payment_type} - ${pay.amount}`)
        .join("\n");
    }
  }
      var rows = Data;
      var doc = jsPDF({
        orientation: "landscape",
      });
      doc.setFontSize(14);
      // doc.setFontType("bold");
      doc.setTextColor(26, 26, 26);
      doc.setFont("helvetica", "bold");
      doc.text("Food Order Report", 130, 5);
      doc.setFontSize(11);
      doc.text(15, 5, `${moment(today).format("DD-MM-YYYY HH:MM:SS")}`);

      doc.setFontSize(11);
      doc.text(15, 12, `Total Amount :- ${this.total}.00`);
      doc.text(100, 12, `Paid Total :- ${this.paidamount}.00`);
      doc.text(170, 12, `Discount Total :- ${this.descount}.00`);
      doc.text(240, 12, `Service Charge:- ${this.servicecharge}.00`);
     doc.autoTable(
  this.headers.map((h) => {
    return { title: h.text, dataKey: h.value };
  }),
  rows,
  {
    styles: {
      halign: 'center',   // center ALL column text
      valign: 'middle',
    },
    headStyles: {
      halign: 'center',   // center header text
    },
     columnStyles: {
    products: { halign: 'left' },   // Food items left-align (more readable)
  },
    didParseCell: function (data) {
      if (data.column.dataKey === "addsress") {
        data.cell.text = data.cell.raw.country;
      }
    },
  }
);

      doc.save(`${moment(today).format("DD-MM-YYYY")}-foodorders.pdf`);
    },
    //Product Details Export Excel
    exceldownload() {
      var data = document.getElementById("indextable");
      const today = new DateTime();
      const headData = XLSX.utils.table_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        wb,
        headData,
        moment(today).format("DD-MM-YYYY")
      );
      XLSX.writeFile(
        wb,
        `${moment(today).format("DD-MM-YYYY")}-foodorders.xlsx`
      );
    },
    StatusChenge(status) {
      switch (status) {
        case "receiving":
          return "Receiving";
          break;
        case "pending":
          return "Pending";
          break;
        case "partially_paid":
          return "Partially Paid";
          break;
        case "paid":
          return "Paid";
          break;
        case "completed":
          return "Completed";
          break;
        case "cancelled":
          return "Cancelled";
          break;
        case "suspended":
          return "Suspended";
          break;
        default:
          break;
      }
    },
    OrderTypeChenge(ordertype) {
      switch (ordertype) {
        case "dine_in":
          return "Dine In";
          break;
        case "take_away":
          return "Take Away";
          break;
        case "service_order":
          return "Service Order";
          break;
        default:
          break;
      }
    },
    onClearFilters() {
      this.foodorders = [];
      this.hide = false;

      this.$nextTick(() => {
        this.generateReport();
      });
    },
    filterText(value, search, item) {
      if (value != null && search != null && typeof value !== "object") {
        return (
          value
            .toString()
            .toLowerCase()
            .indexOf(search.toLowerCase()) !== -1
        );
      } else if (value != null && search != null && typeof value === "object") {
        // Check if it's the items array
        if (Array.isArray(value)) {
          return value.some((food) => {
            const dishName = food.dish ? food.dish.name : "";
            const productName = food.product ? food.product.name : "";
            return (
              dishName.toLowerCase().includes(search.toLowerCase()) ||
              productName.toLowerCase().includes(search.toLowerCase())
            );
          });
        }
      }
      return false;
    },
  },
  computed: {
    dateRangeText() {
      this.filter.start = this.date_range[0];
      this.filter.end = this.date_range[1];
      return this.date_range.join(" ~ ");
    },
    headers: function() {
      return this.columns.filter((item) => item.show == true);
    },
  },
};
</script>
